import { Paper } from '@trackman/web-shared-components';
import { TabListItem, TabListWrapper } from 'components/ui/TabList/TabListStyles';
import React from 'react';
import styled, { css } from 'styled-components';
import { brand } from 'styles/Colors';

const Dot = css`
  height: 8px;
  width: 8px;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
  margin-right: 8px;
`;

export const ArchivesTableCell = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ArchivesWrapper = styled.div`
  padding: 0 !important;
  margin-top: -27px;

  ${TabListWrapper} ul {
    margin-bottom: 10px;
    border-bottom: 2px solid #e0e0e0;

    ${TabListItem} {
      font-family: Oswald;
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      line-height: 25.2px;
      letter-spacing: 0.6px;
      text-transform: uppercase;
      padding: 5px 0 15px;

      &.active {
        border: none !important;
        position: relative;

        &::after {
          content: '';
          display: block;
          border-bottom: 2px solid #ec691a;
          width: 100%;
          position: absolute;
          bottom: -2px;
          left: 0px;
        }
      }
    }
  }

  .MuiPaper-root {
    position: relative;
    min-height: 177px;
    overflow-y: hidden;
  }

  .MuiTableRow-root {
    padding: 0 10px;
  }
`;

export const TableContainer = styled((props) => <Paper {...props} />)`
  &&& {
    padding: 10px;
  }
`;

export const Title = styled.div`
  display: flex;
  gap: 12px;
  align-items: flex-end;
  padding: 0 0 24px;
`;

export const Headline = styled.span`
  color: #414141;
  font-family: Oswald;
  font-size: 22px;
  font-weight: 500;
  line-height: 30.8px;
  letter-spacing: 0.7px;
  text-transform: uppercase;
`;

export const Explainer = styled.span`
  color: #414141;
  font-family: Lato;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
`;

export const LoaderWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 99999;
  background: rgba(0, 0, 0, 0.1);
  svg {
    top: 50%;
    position: absolute;
    left: calc(50% - 25px);
    width: 50px;
    height: 50px;
  }
`;

export const Status = styled.div`
  .dot {
    @include dot;
  }

  &.not-reviewed {
    .dot {
      background-color: $warningred;
    }
  }
  &.submitted {
    .dot {
      background-color: $acceptgreen;
    }
  }
`;

export const StyledUploadStatus = styled.div`
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 7px;

  button {
    min-width: 87px;
    margin-top: 13px;
  }
  .MuiTableCell-root {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .MuiTable-root div {
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const LoadMore = styled.div`
  cursor: pointer;
  text-transform: uppercase;
  font-family: Oswald;
  font-size: 15px;
  font-weight: 500;
  line-height: 1;
  letter-spacing: 0.5px;
  text-align: center;
  color: ${brand};
  margin-top: 15px;
  margin-bottom: 5px;
`;
